var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgOrderQuestion = function SvgOrderQuestion(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.055 20.6h-4.5v-1.215a8.175 8.175 0 0 1 .735-3.72 11.176 11.176 0 0 1 2.88-3.285c.917-.73 1.78-1.528 2.58-2.385A3.24 3.24 0 0 0 14.395 8a3.39 3.39 0 0 0-1.14-2.58 4.5 4.5 0 0 0-3.135-1.065 4.62 4.62 0 0 0-3.15 1.11A6 6 0 0 0 5.215 8.9l-4.5-.585a7.935 7.935 0 0 1 2.7-5.535A9.345 9.345 0 0 1 9.91.5a9.645 9.645 0 0 1 6.795 2.31 7.05 7.05 0 0 1 2.535 5.355 6.09 6.09 0 0 1-.93 3.225 20.759 20.759 0 0 1-3.96 4.11 7.815 7.815 0 0 0-1.95 2.16 7.305 7.305 0 0 0-.345 2.925v.015zm-4.5 6.9v-5.115h4.965V27.5H7.555z",
    fill: "#B3B9CB"
  })));
};

export default SvgOrderQuestion;